import EmbeddedPublication from './EmbeddedPublication';

export default EmbeddedPublication;
